/**
 * 判断建联时间、TTFB 和 FCP/TTFB 比例是否超过阈值，超过判定为异常访问
 * @param connectionThresholdTime 判断建联时间的阈值
 * @param ttfbThreshold 判断 TTFB 的阈值
 * @param fcpToTtfbRatio 判断 FCP 是 TTFB 的几倍的阈值
 * @returns
 */
export function isNetWorkGreaterThanLimit(
  connectionThresholdTime = 300,
  ttfbThreshold = 600,
  fcpToTtfbRatio = 10
) {
  let isConnectionTimeExceeded = false;
  let isTtfbExceeded = false;
  let isFcpToTtfbRatioExceeded = false;
  let logs: string[] = [];

  const log = (message: string) => {
    logs.push(message);
  };

  const navigationEntry = performance.getEntriesByType(
    'navigation'
  )[0] as PerformanceNavigationTiming;

  if (!navigationEntry) {
    log('导航时序数据不可用。');
    console.info(logs.join('\n'));
    return false;
  }

  // 计算网络时间组成部分
  const dnsTime = navigationEntry.domainLookupEnd - navigationEntry.domainLookupStart;
  const tcpTime = navigationEntry.connectEnd - navigationEntry.connectStart;
  const tlsTime =
    navigationEntry.secureConnectionStart > 0
      ? navigationEntry.connectEnd - navigationEntry.secureConnectionStart
      : 0;
  const connectionTime = dnsTime + tcpTime + tlsTime; // 建联时间
  const ttfbTime = navigationEntry.responseStart - navigationEntry.requestStart; // TTFB 时间

  log(`DNS 时间: ${dnsTime}ms`);
  log(`TCP 时间: ${tcpTime}ms`);
  log(`TLS 时间: ${tlsTime}ms`);
  log(`建联时间: ${connectionTime}ms`);
  log(`TTFB 时间: ${ttfbTime}ms`);

  // 检查建联时间和 TTFB 时间是否超过阈值
  if (connectionTime > connectionThresholdTime) {
    log(`建联时间超过阈值 ${connectionThresholdTime}ms: ${connectionTime}ms`);
    isConnectionTimeExceeded = true;
  }
  if (ttfbTime > ttfbThreshold) {
    log(`TTFB 时间超过阈值 ${ttfbThreshold}ms: ${ttfbTime}ms`);
    isTtfbExceeded = true;
  }

  // 设置观察者以追踪 FCP
  const observer = new PerformanceObserver(list => {
    const entries = list.getEntriesByName('first-contentful-paint');
    if (entries.length > 0) {
      const fcpTime = entries[0].startTime;
      log(`FCP 时间: ${fcpTime}ms`);

      // 检查 FCP/TTFB 比例是否超过阈值
      if (ttfbTime > 0 && fcpTime / ttfbTime > fcpToTtfbRatio) {
        log(`FCP/TTFB 比例超过阈值 ${fcpToTtfbRatio}: ${fcpTime / ttfbTime}`);
        isFcpToTtfbRatioExceeded = true;
      }

      // 输出最终判断结果
      if (isConnectionTimeExceeded || isTtfbExceeded || isFcpToTtfbRatioExceeded) {
        log('最终判断结果: 异常访问');
      } else {
        log('最终判断结果: 正常访问');
      }
      console.info(logs.join('\n'));
    }
  });

  observer.observe({ type: 'paint', buffered: true });

  return isConnectionTimeExceeded || isTtfbExceeded || isFcpToTtfbRatioExceeded;
}
